import React, { useState, useMemo } from 'react';

import {
    Grid,
    Divider,
    Collapse,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme
} from '@mui/material';

import { ExpandLess, ExpandMore } from '@mui/icons-material';

// Components
import TotalPayed from './totalPayed';

// Hooks
import useStyles from "./styles";

// Models
import { utils } from '../../utils/utils';
import { OrderStates } from '../../models/OrderEntity';

//TODO cambiar esto para Detalle
const OrderTotals = ({ order, totalPayedAmount }) => {
    const { classes } = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('xl'));
    const [expanded, setExpanded] = useState(matches);

    const totalPerceptionAmount = useMemo(() =>
        order.perceptions?.reduce((a, b) => a + (b.amount || 0), 0)
        , [order.perceptions])

    return (
        <Grid container direction='column' spacing={2}>
            <Grid container direction='column'>
                <Grid container alignItems='baseline' justifyContent='space-between'>
                    <Typography variant='subtitle1' component='span' id='subtotalTitle'>
                        SubTotal:
                    </Typography>
                    <Typography variant='subtitle1' component='span' id='subtotalAmount'>
                        {order.currency} <strong>{utils.formatMoney(order.subAmount)}</strong>
                    </Typography>
                </Grid>
                {
                    (order.orderState === OrderStates.Initiated || order.orderState === OrderStates.PaymentRefused) &&
                    <TotalPayed
                        totalPayed={totalPayedAmount}
                        currency={order.currency}
                        showAlways={false}
                        variant='subtitle1'
                    />
                }
                {
                    !!order.shippingData?.amount &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='subtitle1' component='span' id='shippingTitle'>
                            Costo de envío:
                        </Typography>
                        <Typography variant='subtitle1' component='span' color='error' id='shippingAmount'>
                            {order.currency} <strong>{utils.formatMoney(order.shippingData.amount)}</strong>
                        </Typography>
                    </Grid>
                }
                {
                    !!order.discount &&
                    order.discount - (order.changeDiscount?.amount || 0) > 0 &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='subtitle1' component='span' id='discountTitle'>
                            Descuento:
                        </Typography>
                        <Typography className={classes.success} variant='subtitle1' component='span' id='discountAmount'>
                            {order.currency} <strong>{utils.formatMoney(order.discount - (order.changeDiscount?.amount || 0))}</strong>
                        </Typography>
                    </Grid>
                }
                {
                    !!order.changeDiscount &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='subtitle1' component='span' id='changeDiscountTitle'>
                            {order.changeDiscount.description}
                        </Typography>
                        <Typography className={classes.success} variant='subtitle1' component='span' id='changeDiscountAmount'>
                            {order.currency} <strong>{utils.formatMoney(order.changeDiscount.amount)}</strong>
                        </Typography>
                    </Grid>
                }
                {
                    !!order.interest &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='subtitle1' component='span' id='interestTitle'>
                            Interes:
                        </Typography>
                        <Typography variant='subtitle1' component='span' color='error' id='interestAmount'>
                            {order.currency} <strong>{utils.formatMoney(order.interest)}</strong>
                        </Typography>
                    </Grid>
                }
                <Grid>
                    <Divider />
                </Grid>
                {
                    !!order.refund &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='subtitle1' component='span' id='refundTitle'>
                            Devolucion Bancaria:
                        </Typography>
                        <Typography className={classes.success} variant='subtitle1' component='span' id='refundAmount'>
                            {order.currency} <strong>{utils.formatMoney(order.refund)}</strong>
                        </Typography>
                    </Grid>
                }
                {
                    !!order.round &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='subtitle1' component='span' id='roundTitle'>
                            Redondeo:
                        </Typography>
                        <Typography variant='subtitle1' component='span' color='error' id='roundAmount'>
                            {order.currency} <strong>{utils.formatMoney(order.round)}</strong>
                        </Typography>
                    </Grid>
                }
                {order.perceptions &&
                    order.perceptions.length > 0 &&
                    <>
                        <Grid container alignItems='baseline' justifyContent='space-between'>
                            <Typography variant='subtitle1' component='span' id='perceptionTitle'>
                                Percepciones:
                            </Typography>
                            <Typography variant='subtitle1' component='span' color='error' id='perceptionAmount'>
                                {order.currency} <strong>{utils.formatMoney(totalPerceptionAmount)}</strong>
                                <IconButton
                                    onClick={() => setExpanded(!expanded)}
                                    className={classes.buttonPerception}
                                    size="large"
                                >
                                    {expanded ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Typography>
                        </Grid>
                        <Grid>
                            <Collapse in={expanded}>
                                {
                                    order?.perceptions?.map((item, index) =>
                                        <Grid
                                            container
                                            alignItems='baseline'
                                            justifyContent='space-between'
                                            key={index}
                                        >
                                            <Typography variant='subtitle1' component='span' id='perceptionItemTitle'>
                                                {item.description}
                                            </Typography>
                                            <Typography variant='subtitle1' component='span' color='error' id='perceptionItemAmount'>
                                                {order.currency} <strong>{utils.formatMoney(item.amount)}</strong>
                                            </Typography>
                                        </Grid>
                                    )
                                }
                            </Collapse>
                        </Grid>
                        <Grid>
                            <Divider />
                        </Grid>
                    </>
                }
                {
                    (order.orderState !== OrderStates.Initiated && order.orderState !== OrderStates.PaymentRefused) &&
                    <TotalPayed
                        totalPayed={totalPayedAmount}
                        currency={order.currency}
                        showAlways
                        variant='h6'
                    />
                }
                {
                    (order.orderState === OrderStates.Initiated || order.orderState === OrderStates.PaymentRefused) &&
                    <Grid container alignItems='baseline' justifyContent='space-between'>
                        <Typography variant='h6' component='span'>
                            {`Total a ${totalPayedAmount > order.amount ? 'devolver' : 'pagar'}:`}
                        </Typography>
                        <Typography className={totalPayedAmount > order.amount ? classes.success : null} variant='h6' component='span'>
                            {order.currency} <strong>{utils.formatMoney(Math.abs(order.amount - totalPayedAmount))}</strong>
                        </Typography>
                    </Grid>
                }
            </Grid>
        </Grid>
    );
}
export default OrderTotals;